import { defineQuery } from 'next-sanity'
import { imageFields } from '../atoms'

export const careersTextCollageBlockFields = `
  _id,
  _type,
  mainText,
  collageImage1 {
    ${imageFields}
  },
  collageImage2 {
    ${imageFields}
  },
  collageImage3 {
    ${imageFields}
  }
`

export const CAREERS_TEXT_COLLAGE_BLOCK_QUERY = defineQuery(/* groq */ `
  *[_type == "careers-text-collage-block"][0]{
    ${careersTextCollageBlockFields}
  }
`)
